console.log("bundle-modal.js file parsed");

(function waitForjQuery() {
    if (typeof window.jQuery === "function") {
        console.log("bundle-modal.js jQuery loaded");
        initBundleModal(window.jQuery);
    } else {
        console.log("bundle-modal.js jQuery not yet loaded");
        setTimeout(waitForjQuery, 30);
    }
})();

function initBundleModal($) {
    console.log("bundle-modal.js init start");

    var ACTIVE = false;
    var $activeElement = null;

    function resizeBundleModal() {
        var $modal = $(".quick-view-bundle");
        var $content = $modal.find(".content");
        if (!$content.length) return;

        var wh = $(window).height();
        var ch = $content.outerHeight() + 50;

        if (wh - ch >= 60) {
            var top = Math.max(0, (wh - ch) / 2);
            $content.css({ marginTop: top, marginBottom: top });
            $modal.removeClass("overflow-center");
        } else {
            $modal.addClass("overflow-center");
            $content.css("margin", "30px auto");
        }
    }

    function closeBundleModal() {
        if ($activeElement && $activeElement.data("orig-parent")) {
            var $parent = $activeElement.data("orig-parent");
            var $next = $activeElement.data("orig-next");

            if ($next && $next.length) {
                $activeElement.insertBefore($next);
            } else {
                $parent.append($activeElement);
            }
        }

        $("html").removeClass("overflow-hidden");

        $(".quick-view-bundle").fadeOut(200, function () {
            $(this).empty();
            ACTIVE = false;
            $activeElement = null;
        });
    }

    // OPEN
    $(document).on("click", "a.ksmodal-bundle", function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (ACTIVE) return;
        ACTIVE = true;

        console.log("bundle-modal clicked");

        var id = $(this).attr("data-target-id");
        var $element = $("#" + id);
        if (!$element.length) {
            ACTIVE = false;
            return;
        }

        // STORE ORIGINAL POSITION (ONCE)
        if (!$element.data("orig-parent")) {
            $element.data("orig-parent", $element.parent());
            $element.data("orig-next", $element.next());
        }

        var html =
            '<div class="overlay"></div>' +
            '<div class="content clearfix">' +
                '<div class="content-inner clearfix">' +
                    '<div class="ksmodal-content-box col-xs-12"></div>' +
                '</div>' +
                '<a href="#" class="close-window">Close</a>' +
            '</div>';

        var $modal = $(".quick-view-bundle");
        $modal.html(html);

        var $box = $modal.find(".ksmodal-content-box");
        if (!$box.length) {
            ACTIVE = false;
            return;
        }

        // MOVE (NOT CLONE)
        $box.append($element.show());
        $activeElement = $element;

        $("html").addClass("overflow-hidden");
        $modal.fadeIn(200);

        resizeBundleModal();
    });

    // PREVENT INNER CLICK CLOSE
    $(document).on("click", ".quick-view-bundle .content", function (e) {
        e.stopPropagation();
    });

    // CLOSE
    $(document).on("click", ".quick-view-bundle .overlay, .quick-view-bundle .close-window", function (e) {
        e.preventDefault();
        closeBundleModal();
    });

    // ESC
    $(document).on("keyup", function (e) {
        if (e.keyCode === 27) closeBundleModal();
    });

    // RESIZE
    $(window).on("resize", resizeBundleModal);
}
